import { createContext, createRef } from 'react';
import { AppearanceType } from '../appearance';
import { type AppRootContextDefinition } from './interfaces';
import { Mode } from './enums';
import { FALLBACK_SAFE_AREA_INSETS } from './const';

export const Context = createContext<AppRootContextDefinition>({
  appRoot: createRef(),
  scrollable: createRef(),
  mode: Mode.FULL,
  appearance: AppearanceType.LIGHT,
  safeAreaInsets: FALLBACK_SAFE_AREA_INSETS,
  contentSafeAreaInsets: FALLBACK_SAFE_AREA_INSETS,
  registerContentSafeAreaInsets: () => void 0,
  unregisterContentSafeAreaInsets: () => void 0,
});
